var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iande-chart-wrapper"},[_c('h2',[_vm._v(_vm._s(_vm.__('Faixa etária dos grupos', 'iande')))]),_vm._v(" "),_c('ApexChart',{attrs:{"type":"bar","series":_vm.series,"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }